<template>
  <v-flex>
    <v-card class="mx-auto" max-width="400" align="center">
      <v-card-text> </v-card-text>
      <v-avatar
        ><v-img align="center" src="/cobranzasIcon.png" width="50px"></v-img
      ></v-avatar>
      <v-list-item two-line>
        <v-list-item-content>
          <v-toolbar-title class="font-weight-black primary--text"
            >Sistema de Cobranzas</v-toolbar-title
          >
          <v-list-item-subtitle align="center">{{
            "Iniciar Sesión"
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-card-text>
        <v-flex class="red--text" v-if="error">
          {{ error }}
        </v-flex>
        <v-flex class="green--text" v-if="logoutMessage">
          {{ logoutMessage }}
        </v-flex>
        <p class="text-center mb-4">
          Inicia sesión con tu cuenta de Microsoft
        </p>
      </v-card-text>
      
      <v-card-actions class="px-3 pb-3" align="center">
        <v-flex text-xs-center>
          <v-btn 
            @click="loginWithMicrosoft" 
            :loading="load" 
            color="primary"
            large
            style="background-color: #0078d4 !important"
          >
            <v-icon left>mdi-microsoft</v-icon>
            Iniciar sesión con Microsoft
          </v-btn>
        </v-flex>
      </v-card-actions>
      
      <v-card-text> </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import axios from "axios";
import authService from "../services/authService.js";

export default {
  data() {
    return {
      load: false,
      error: null,
      logoutMessage: null,
    };
  },
  mounted() {
    // Verificar si venimos de un logout
    this.checkForLogoutParameter();
    
    // Verificar si hay errores en la URL
    this.checkForErrorParameter();
    
    // Verificar si hay un token en la URL (venir del backend post-login)
    const tokenProcessed = this.checkForTokenInUrl();
    
    // Solo verificar el estado de autenticación si no se procesó un token de la URL
    if (!tokenProcessed) {
      this.checkAuthStatus();
    }
  },
  methods: {
    checkForLogoutParameter() {
      const urlParams = new URLSearchParams(window.location.search);
      const logout = urlParams.get('logout');
      
      if (logout === 'true') {
        this.logoutMessage = "Sesión cerrada correctamente";
        // Limpiar la URL
        window.history.replaceState({}, document.title, window.location.pathname);
        
        // Ocultar el mensaje después de 3 segundos
        setTimeout(() => {
          this.logoutMessage = null;
        }, 3000);
      }
    },
    checkForErrorParameter() {
      const urlParams = new URLSearchParams(window.location.search);
      const error = urlParams.get('error');
      
      if (error) {
        let errorMessage = "Error en el proceso de autenticación";
        
        switch (error) {
          case 'no_email':
            errorMessage = "No se pudo obtener el email del usuario. Verifique que su cuenta tenga un email válido.";
            break;
          case 'auth_failed':
            errorMessage = "Error en la autenticación con Microsoft. Inténtelo nuevamente.";
            break;
          case 'user_not_found':
            errorMessage = "Su usuario no está registrado en el sistema de cobranzas. Contacte al administrador.";
            break;
          default:
            errorMessage = `Error de autenticación: ${error}`;
        }
        
        this.error = errorMessage;
        
        // Limpiar la URL
        window.history.replaceState({}, document.title, window.location.pathname);
        
        // Ocultar el error después de 10 segundos
        setTimeout(() => {
          this.error = null;
        }, 10000);
      }
    },
    checkForTokenInUrl() {
      // Verificar si hay un token en los parámetros de URL
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');
      
      if (token) {
        console.log('Token encontrado en URL, procesando...');
        // Si hay token, guardarlo y redirigir al Home
        this.$store.dispatch("guardarToken", token);
        
        // Limpiar la URL removiendo el token
        window.history.replaceState({}, document.title, window.location.pathname);
        
        // Asegurar que la redirección ocurra después de que el store se actualice
        this.$nextTick(() => {
          console.log('Redirigiendo a Home...');
          this.$router.push({ name: "Home" });
        });
        return true;
      }
      return false;
    },
    async checkAuthStatus() {
      try {
        const { isAuthenticated, user } = await authService.checkAuthStatus();
        
        if (isAuthenticated && user && user.token) {
          // El usuario ya está autenticado, obtener el token
          this.$store.dispatch("guardarToken", user.token);
          this.$router.push({ name: "Home" });
        }
      } catch (err) {
        console.error('Error al verificar estado de autenticación:', err);
        // Si hay error, continuar con el flujo normal de login
      }
    },
    
    async loginWithMicrosoft() {
      this.error = null;
      this.load = true;
      
      try {
        // Usar el servicio de autenticación para el login
        authService.loginWithMicrosoft();
      } catch (err) {
        console.error('Error al iniciar login:', err);
        this.load = false;
        this.error = "Error al iniciar sesión con Microsoft";
      }
    },
  },
};
</script>
